import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import {CardTitle, OutlineButton, P2} from "../Kit/Kit";
import frozenIcon from '../../assets/img/frozenIcon.jpg';
import freshIcon from '../../assets/img/freshIcon.jpg';

const Container = styled.div`
  padding-top: 50px;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  grid-column-gap: 24px;
  position: relative;
  margin-bottom: 32px;
  grid-row-gap: 16px;
  
  @media(min-width: 768px) {
    grid-template-columns: ${props => props.leftImg ? '1fr 2fr' : '2fr 1fr'};
    padding-top: 100px;
    margin-bottom: 100px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  order: 2;
  z-index: 2;
  
  @media(min-width: 768px) {
    order: 1;
  }
  
  a {
    margin-top: 30px;
  }
`;

const Name = CardTitle.extend`
  margin-right: 12px;
  text-align: left;
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const Summary = P2.extend`
  text-align: left;
`;

const FreshIcon = styled.img`
  margin-right: 10px;
  display: ${props => props.render ? 'block' : 'none'}
`;

const FrozenIcon = FreshIcon.extend`

`;

const ProductImg = styled.img`
  width: 100%;
  order: 1;
  z-index: 2;
  
  @media(min-width: 768px) {
    order: ${props => props.leftImg ? '1' : '2'};
  }
`;

const BackgroundText = styled.div`
  display: none;
  position: absolute;
  top: 0;
  color: #f6f6f6;
  font-family: Cabin-Bold, sans-serif;
  z-index: 1;
  
  @media(min-width: 768px) {
    display: block;
    font-size: 75px;
  }
  
  @media(min-width: 992px) {
    ${props => props.leftImg ? 'left: 0' : 'right: 0'};
    font-size: 100px;
  }
  
  @media(min-width: 1200px) {
    font-size: 125px;
  }
  
  @media(min-width: 1680px) {
    font-size: 170px;
  }
  
`;

const SingleProduct = (props) => {
    const {name, fresh, frozen, summary, img, slug, index} = props;
    const leftImg = (index % 2 === 0);
    if (!leftImg) {
        return (
          <Container>
              <BackgroundText>{name}</BackgroundText>
              <TextContainer>
                  <NameContainer>
                      <Name>{name}</Name>
                      <FreshIcon src={freshIcon} render={fresh}/>
                      <FrozenIcon src={frozenIcon} render={frozen}/>
                  </NameContainer>
                  <Summary
                    dangerouslySetInnerHTML={{__html: summary}}
                  />
                  <Link to={`/${slug}`} title={`Read More About ${name}`}><OutlineButton>Read
                      More</OutlineButton></Link>
              </TextContainer>
              <ProductImg src={img.source_url} alt={img.alt_text}/>
          </Container>
        );
    }
    return (
      <Container leftImg={leftImg}>
          <BackgroundText leftImg={leftImg}>{name}</BackgroundText>
          <ProductImg src={img.source_url} alt={img.alt_text} leftImg={leftImg}/>
          <TextContainer>
              <NameContainer>
                  <Name>{name}</Name>
                  <FreshIcon src={freshIcon} render={fresh}/>
                  <FrozenIcon src={frozenIcon} render={frozen}/>
              </NameContainer>
              <Summary
                dangerouslySetInnerHTML={{__html: summary}}
              />
              <Link to={`/${slug}`} title={`Read More About ${name}`}><OutlineButton>Read More</OutlineButton></Link>
          </TextContainer>
      </Container>
    )

};

export default SingleProduct;



// WEBPACK FOOTER //
// ./src/components/ProductInfo/SingleProduct.js